<template>
  <li class="sj-question-file-item sj-question-file-add">
    <slot>
      <el-button type="text"
                 :icon="icon"
                 :disabled="disabled"
                 v-on="$listeners"></el-button>
    </slot>
  </li>
</template>

<script>

export default {
  components: {},
  mixins: [],
  props: {
    icon: {
      type: String,
      default: 'sj-icon-add-image',
    },
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>
<style lang="scss">
.sj-question-file-add {
  button {
    color: #E4E7ED;
    font-size: 73px;
    padding: 0;

    &:hover {
      color: #C0C4CC;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-file/src/SjQuestionFileAdd.vue